import u from 'umbrellajs';

import {
	clickElement,
	addClassElement,
	checkElement2,
	hideElement,
	autoClickFirstImageComponent,
	setReadOnlyComponent,
	addTextComponentInsideEditor,
	addImageComponentInsideEditor,
	checkWindowVariableChangedToTrue,
	setAllComponentsReadOnlyButTextAndImage,
} from './domUtils';

import { addJSToTemplate, generateWidgetsInHTML, makeContactInfoReadOnly } from './utils';

const createMutationObserver = (colorPickerSelector) => {
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			// console.log('mutation', mutation);
			if (mutation.type === 'attributes') {
				const classList = mutation.target.getAttribute('class') || '';
				let querySelector;
				if (classList.includes('gjs-sm-color-color-picker')) {
					querySelector = '.gjs-sm-color-color-picker';
				} else if (classList.includes('gjs-sm-background-color-color-picker')) {
					querySelector = '.gjs-sm-background-color-color-picker';
				} else if (classList.includes('gjs-sm-border-color-color-picker')) {
					querySelector = '.gjs-sm-border-color-color-picker';
				}
				if (!querySelector) return;
				const colorPickerElementNow = document.querySelector(querySelector);
				if (!colorPickerElementNow) return;
				const style = colorPickerElementNow.getAttribute('style');
				let value;
				if (style) {
					value = style.substring(style.indexOf(':') + 1, style.indexOf(';'));
				} else {
					value = 'white';
				}
				// console.log('attributes changed', mutation.target);
				// console.log('attributes changed', classList);
				// console.log('attributes changed', value);
				const path = colorPickerElementNow.querySelector('path');
				if (path) path.setAttribute('style', `fill: ${value}`);
				// const allPaths = colorPickerElementNow.querySelectorAll('path');
				// allPaths.forEach(path => {
				//   path.setAttribute('style', `fill: ${value}`);
				// });
				// colorPickerElement.removeAttribute('style');
			}
		});
	});
	const colorPickerElements = document.querySelectorAll(colorPickerSelector);
	colorPickerElements.forEach((colorPickerElement) => {
		observer.observe(colorPickerElement, {
			attributes: true,
		});
	});
};

const toggleFontWeight = () => {
	const boldStatus = document.querySelector('.font-weight-checkbox').classList.contains('bold');
	console.log('toggleFontWeight', boldStatus);
	if (boldStatus) {
		const selector = "input[id*='font-weight-400']";
		checkElement2(selector).then(() => {
			document.querySelector(selector).click();
			document.querySelector('.font-weight-checkbox').classList.remove('bold');
		});
	} else {
		const selector = "input[id*='font-weight-700']";
		checkElement2(selector).then(() => {
			document.querySelector(selector).click();
			document.querySelector('.font-weight-checkbox').classList.add('bold');
		});
	}
};

const addCheckboxEmulateRadioFontWeight = () => {
	const element = document.createTextNode('');

	//  <label class="switch">
	//         <input class="font-weight-checkbox" type="checkbox" />
	//         <span class="slider round"></span> </label
	//       >

	element.innerHTML = `
          <div class="font-weight-checkbox">B</div>
                `;
	checkElement2('#gjs-sm-font-weight .gjs-field-radio').then((parentElement) => {
		parentElement.insertAdjacentHTML('afterbegin', element.innerHTML);
		document.querySelector('.font-weight-checkbox').addEventListener('click', toggleFontWeight);
	});
};

const addTextComponentToTopBar = () => {
	const html = `
      <div class="gjs-pn-btn text-component">
        T
      </div>
    `;

	u('.gjs-pn-options .gjs-pn-buttons').prepend(html);
	u('.text-component').handle('click', addTextComponentInsideEditor);
};

const addImageComponentToTopBar = () => {
	const html = `
      <div class="gjs-pn-btn fa fa-picture-o image-component">
      </div>
    `;

	u('.gjs-pn-options .gjs-pn-buttons').prepend(html);
	u('.image-component').handle('click', addImageComponentInsideEditor);
};

export const startPreviewMode = (editor, template, testimonials) => {
	setTimeout(() => {
		addJSToTemplate();
		try {
			const { startPreviewMode: startTemplatePreviewMode } =
				window.grapesjs.Canvas.getWindow();
			if (startTemplatePreviewMode) {
				startTemplatePreviewMode(template, testimonials);
			}
		} catch (error) {
			console.log('startPreviewMode', error);
		}
		// Preview mode default 2 widgets
		const widgetsIds = ['widget-edu', 'widget-insurance'];
		generateWidgetsInHTML(widgetsIds);
	}, 500);

	editor.DomComponents.getWrapper().onAll((comp) => {
		setReadOnlyComponent(comp);
	});
	const previewButton = document.querySelector('.gjs-off-prv');
	if (previewButton) {
		previewButton.setAttribute('style', 'display: none;');
	}
};

export const onLoadEditor = (editor, eventName) => {
	console.log('TCL: onLoadEditor', eventName);

	if (eventName === 'load') {
		clickElement('span[title="Open Style Manager"]');
	}

	addClassElement('#gjs-sm-color .gjs-field-color-picker', 'gjs-sm-color-color-picker');
	addClassElement(
		'#gjs-sm-background-color .gjs-field-color-picker',
		'gjs-sm-background-color-color-picker',
	);
	addClassElement(
		'#gjs-sm-border-color .gjs-field-color-picker',
		'gjs-sm-border-color-color-picker',
	);

	createMutationObserver('.gjs-field-color-picker');

	addCheckboxEmulateRadioFontWeight();

	// Hide Preview if in report cover mode
	if (window.GM_BRANDING_TYPE_REPORT_EBOOK) {
		hideElement('.gjs-pn-devices-c .gjs-pn-buttons');

		addTextComponentToTopBar();
		addImageComponentToTopBar();
	} else {
		// hide reset template in website mode
		hideElement('.reset-button');
	}

	if (!window.GM_BRANDING_TYPE_REPORT_EBOOK) {
		checkWindowVariableChangedToTrue('grapesjsLoadTemplateCompleted').then(() => {
			autoClickFirstImageComponent();
			setAllComponentsReadOnlyButTextAndImage();
			makeContactInfoReadOnly();
		});
	}
};
